import { bindContributionProvider } from "@visactor/vrender-core";

import { MathPickerContribution } from "../constants";

let loaded = !1;

export function bindMathPickerContribution(c) {
    loaded || (loaded = !0, bindContributionProvider(c.bind.bind(c), MathPickerContribution));
}
//# sourceMappingURL=module.js.map
